import { render } from "./messageTemplate.vue?vue&type=template&id=452b20ea&scoped=true"
import script from "./messageTemplate.vue?vue&type=script&lang=js"
export * from "./messageTemplate.vue?vue&type=script&lang=js"

import "./messageTemplate.vue?vue&type=style&index=0&id=452b20ea&scoped=true&lang=css"

import exportComponent from "/home/wido/Documents/Project/SS-GreedGreed/ss-web-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452b20ea"]])

export default __exports__